export default function getCSSThemeClassName(
  css,
  prefix: string,
  theme: string,
) {
  return css?.[`${prefix}-${theme}`]
}
